import i18next from "i18next";
import { LOADING, LOGOUT,SET_CURRENT_USER_STATUS, SET_CURRENT_WEBSITE, SET_CURRENT_WEBSITE_DATA, SET_CURRENT_WEBSITE_PLAN_DATA, SET_MESSAGE, SET_WEBSITE_LIST } from "../../Actions/Types";
import { DomainDetailsApi } from "../../Api/DomainApi/DomainDetailsApi";
import { getViolationsCountApi, getViolationsListApi } from "../../Api/ViolationsApi";
import decodeBase64 from "../../Helpers/decodeBase64";
import encodeBase64 from "../../Helpers/encodeBase64";
import parseISODate from "../../Helpers/parseISODate";
import { getPlanListService } from "../PlanListService";

export const CompletePost2FALoginService = async (
  token: string,
  userData: any,
  dispatch: Function,
  navigate: Function,
  t: Function,
  woocommerceToken?: string
) => {
  try {
    const loginWebsiteID = userData.website_lists?.[0]?.id ?? 0;

    // Determine user type
    let currentUserType = 1;
    if (userData.is_extension_user === 1) currentUserType = 5;
    else if (userData.department === 4 && userData.is_multiple_domain === 1) currentUserType = 3;
    else if (userData.department === 4) currentUserType = 2;
    else if (userData.is_multiple_domain === 2) currentUserType = 4;
    
    dispatch({
      type: SET_CURRENT_USER_STATUS,
      payload: {
        currentUserType,
        isInitUser: loginWebsiteID === 0,
      },
    });

    getPlanListService(token, 2, dispatch);

    // If no domain associated, redirect to getting-started
    if (loginWebsiteID === 0) {
      dispatch({ type: SET_WEBSITE_LIST, payload: null });
      dispatch({ type: SET_CURRENT_WEBSITE, payload: null });
      dispatch({ type: LOADING, payload: false });
      navigate(`/front/getting-started`);
      return;
    }

    const domainResponse = await DomainDetailsApi(token, loginWebsiteID);
    if (domainResponse.status !== 200) throw new Error('Invalid domain response');

    const scanDataRes = await getViolationsCountApi(token, loginWebsiteID);
    const scanErrorViolationRes = await getViolationsListApi(token, loginWebsiteID, i18next.language, 0);
    const scanSuccessViolationRes = await getViolationsListApi(token, loginWebsiteID, i18next.language, 1);

    const successAccessibilityChecks = scanDataRes.data[0].successAccessibilityChecks;
    const failingAccessibilityChecks = scanDataRes.data[0].failingAccessibilityChecks;
    const accessibilityScore =
      successAccessibilityChecks + failingAccessibilityChecks > 0
        ? parseFloat(((successAccessibilityChecks / (successAccessibilityChecks + failingAccessibilityChecks)) * 100).toFixed(2))
        : 0;

    const successViolations = scanSuccessViolationRes.total_counts;
    const failedViolations = scanErrorViolationRes.total_counts;
    const violationsRemediatedPercentage =
      successViolations + failedViolations > 0
        ? parseFloat(((successViolations / (successViolations + failedViolations)) * 100).toFixed(2))
        : 0;

    const successImageAlt = scanDataRes.data[0].total_update_alt_text;
    const failedImageAlt = scanDataRes.data[0].missing_alt_text;
    const imageAltRemediatedPercentage =
      successImageAlt + failedImageAlt > 0
        ? parseFloat(((successImageAlt / (successImageAlt + failedImageAlt)) * 100).toFixed(2))
        : 0;

    dispatch({
      type: SET_CURRENT_WEBSITE_DATA,
      payload: {
        accessibilityScore,
        violationsRemediatedPercentage,
        successViolations,
        failedViolations,
        imageAltRemediatedPercentage,
        successImageAlt,
        failedImageAlt,
        successViolationsList: scanSuccessViolationRes.Data,
        failedViolationsList: scanErrorViolationRes.Data,
      },
    });

    // Extract plan info
    const planData = domainResponse.Data?.[0] || {};
    let isExpiredFlag = false,
      isTrialFlag = false,
      isInitFlag = successViolations === 0 && failedViolations === 0,
      isFreeWidget = false,
      isProPlanFlag = false,
      isCanceledPlanFlag = false,
      tempPlanName: string | null = null,
      tempPlanExpiredData: string | null = null;

    if (planData.is_expired === 1 && planData.expired_package_detail?.length) {
      isExpiredFlag = true;
      tempPlanName = planData.expired_package_detail[0].name;
      tempPlanExpiredData = parseISODate(planData.expired_package_detail[0].end_date);
    } else if (planData.is_expired === 3 && planData.current_package_only?.length) {
      isTrialFlag = true;
      tempPlanName = planData.current_package_only[0].name;
      tempPlanExpiredData = parseISODate(planData.current_package_only[0].end_date);
    } else if (planData.canceled_package_only?.length) {
      isCanceledPlanFlag = true;
      tempPlanName = planData.canceled_package_only[0].name;
      tempPlanExpiredData = parseISODate(planData.canceled_package_only[0].end_date);
    } else if (planData.current_package_only?.length) {
      const currentPlan = planData.current_package_only[0];
      isFreeWidget = currentPlan.is_free_widget === 1;
      isProPlanFlag = !isFreeWidget;
      tempPlanName = currentPlan.name;
      tempPlanExpiredData = parseISODate(currentPlan.end_date);
    }

    dispatch({
      type: SET_CURRENT_WEBSITE_PLAN_DATA,
      payload: {
        isExpired: isExpiredFlag,
        isTrial: isTrialFlag,
        isInit: isInitFlag,
        isFreeWidget,
        isProPlan: isProPlanFlag,
        isCanceledPlan: isCanceledPlanFlag,
        planName: tempPlanName,
        planExpiredData: tempPlanExpiredData,
      },
    });

    // Save website and token
    dispatch({ type: SET_CURRENT_WEBSITE, payload: planData });
    dispatch({ type: SET_WEBSITE_LIST, payload: userData.website_lists });

    // Final redirect after Woocommerce logic
    if (woocommerceToken && planData) {
      const [redirectID, planID, planSubID, planInterval] = decodeBase64(woocommerceToken).split('|');
      const domainURL = planData.domain;
      const userID = userData.id;
      const lang = 'en';

      const encoded = encodeBase64(`${planID}|${domainURL}|${planInterval}|${userID}|${lang}|1`);

      const redirectMap: Record<string, string> = {
        ad1: planData.white_label_enabled ? '/front/addon-services/white-label-service' : `/front/package/${encoded}`,
        ad2: '/front/addon-services/custom-branding-service',
        ad3: planData.menu_features_enabled
          ? '/front/addon-services/modify-accessibility-menu'
          : `/front/package/${encoded}`,
        ad4: planData.live_site_translation_enabled
          ? '/front/addon-services/live-site-translation'
          : `/front/package/${encodeBase64(`${planID}|${domainURL}|${planInterval}|${userID}|${lang}|2|${planSubID}`)}`,
        ad5: '/front/addon-services/pdfs',
        ad6: '/front/addon-services/manual-audit-report',
        ad7: '/front/addon-services/vpat-report',
        ad8: '/front/addon-services/manual-remediation',
        ad9: '/front/addon-services/design-audit',
        ad10: '/front/addon-services/native-mobile-app-audit',
        ad11: '/front/addon-services/web-app-spa-audit',
      };

      navigate(redirectMap[redirectID] || '/front');
    } else {
      navigate('/front');
    }

    dispatch({ type: LOADING, payload: false });

    dispatch({
      type: SET_MESSAGE,
      payload: {
        toast_message: t('Login Success Msg'),
        toast_type: 'success',
        onclose: null,
      },
    });
  } catch (err) {
    dispatch({ type: LOGOUT });
    dispatch({ type: LOADING, payload: false });
    navigate(woocommerceToken ? `/front/login?logout=true&token=${woocommerceToken}` : '/front/login?logout');
    dispatch({
      type: SET_MESSAGE,
      payload: {
        toast_message: t('Login Fail Msg'),
        toast_type: 'danger',
        onclose: null,
      },
    });
  }
};
